
define('text!presentation/login/views/closedAndCannotReactivateActionModal.html',[],function () { return '<div></div>';});

